import styled from 'styled-components';
import {
	GroupPerformanceKeys,
	IGroupsPerformances,
	performanceKeys,
	performanceKeysMap,
} from 'type/dashboard';

import { useGetGroupPerformances } from 'hooks/queries/dashboard';
import useGetSearchParams from 'hooks/useGetSearchParams';
import CoreLoading from 'shared/CoreLoading';
import {
	EmphasizeText,
	ReportSectionCard,
	ReportTopHeader,
} from 'styles/styled-components/report';
import style from 'styles/styled-components/style';

function AverageCard() {
	const [groupId] = useGetSearchParams(['groupId']);
	const { data: groupPerformances, isLoading } = useGetGroupPerformances(groupId);

	const avgLikeCount = `${
		groupPerformances?.avgReelsLikeCount
			? Math.trunc(groupPerformances.avgReelsLikeCount).toLocaleString()
			: '-'
	}/${
		groupPerformances?.avgStyleClipLikeCount
			? Math.trunc(groupPerformances.avgStyleClipLikeCount).toLocaleString()
			: '-'
	}`;

	if (isLoading || !groupPerformances) {
		return (
			<Grid flex="between" wrap="wrap" _gap="16px">
				<DataContainer>
					{performanceKeys.map((key: GroupPerformanceKeys, index: number) => (
						<ReportSectionCard key={index} _width="350px" _height="100px">
							<Grid flex="start" align_items="start" direction="column">
								<ReportTopHeader>{performanceKeysMap[key]}</ReportTopHeader>
								<EmphasizeText>
									<CoreLoading color_type="gray" />
								</EmphasizeText>
							</Grid>
						</ReportSectionCard>
					))}
				</DataContainer>
			</Grid>
		);
	}

	const PerformanceValue = ({
		performanceKey,
		value,
	}: {
		performanceKey: GroupPerformanceKeys;
		value: string | number | null;
	}) => {
		if (value === null) return <span>{'-'}</span>;

		if (performanceKey === 'avgLikeCount') {
			return <span>{value} 개</span>;
		}

		if (
			performanceKey === 'avgCommentCount' ||
			performanceKey === 'avgViewCount' ||
			performanceKey === 'avgEngagement'
		) {
			const formattedValue = Math.trunc(Number(value)).toLocaleString();
			return <span>{formattedValue} 개</span>;
		}

		if (performanceKey === 'avgSentCount' || performanceKey === 'avgClickCount') {
			const formattedValue = Math.trunc(Number(value)).toLocaleString();
			return <span>{formattedValue} 회</span>;
		}

		if (
			performanceKey === 'totalAdvertisingCost' ||
			performanceKey === 'CPV' ||
			performanceKey === 'CPE'
		) {
			const formattedValue = Number(Number(value).toFixed(1)).toLocaleString();
			return <span>{formattedValue} 원</span>;
		}

		const formattedValue = Math.trunc(Number(value)).toLocaleString();
		return <span>{formattedValue}</span>;
	};

	return (
		<Grid flex="between" wrap="wrap" _gap="16px">
			{/* 3 columns으로 나오게 */}
			<DataContainer>
				{performanceKeys.map((key: GroupPerformanceKeys, index: number) => (
					<ReportSectionCard key={index} _width="350px" _height="100px">
						<Grid flex="start" align_items="start" direction="column">
							<ReportTopHeader>{performanceKeysMap[key]}</ReportTopHeader>
							<EmphasizeText>
								<PerformanceValue
									performanceKey={key}
									value={key === 'avgLikeCount' ? avgLikeCount : groupPerformances[key]}
								/>
							</EmphasizeText>
						</Grid>
					</ReportSectionCard>
				))}
			</DataContainer>
		</Grid>
	);
}
export default AverageCard;

const { Grid } = style;

const DataContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 16px;
`;
